export default "__VITE_ASSET__CWLPXQcq__"